module.exports = __webpack_public_path__ + "static/img/6-10073.7236159.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/666/6-10073.png
// module id = io/e
// module chunks = 1